import React from 'react';

export type IDemoButtonProps = {
  onClick(value: string): void;
};

const DemoButton: React.FC<IDemoButtonProps> = ({ onClick }) => {
  if (window.location.hostname !== "localhost") return null;

  return (
    <button
      type="button"
      onClick={() =>
        onClick(
          JSON.stringify({
            app: 'VisIT',
            id: '28c887e0-d2bc-400d-98d1-3c3f960381f4',
          }),
        )
      }
    >
      Emulate QR code
    </button>
  );
};

export default DemoButton;
